exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".C_11B{margin:40px 0;background:#fff;border-radius:8px;padding:20px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1)}._3q4vD{background:#f0f0f0;padding:12px 20px;margin:-20px -20px 20px;border-radius:8px 8px 0 0;font-size:16px;font-weight:600}.EMq0T{display:inline-block}._1IC2I{margin-bottom:10px;font-size:14px}._1IC2I thead{background:#34495e;color:#fff}._1IC2I td,._1IC2I th{text-align:center;vertical-align:middle}._3OfB3 th{border-color:#2c3e50!important}._1S4KX{background:#2c3e50!important;min-width:150px}._1dwj7,._1S4KX{color:#fff!important;font-weight:600}._1dwj7{background:#34495e!important;min-width:120px}.er8jf{font-size:14px;font-weight:700;display:block;margin-top:4px}._2_GSQ{font-size:12px;display:block;margin-top:2px;opacity:.9}._28-sv{width:120px;background:#ecf0f1;font-weight:700;text-align:right!important}._28-sv._1E71u{background:#ffd3da}._1x3u2{width:180px;font-weight:500;color:#27ae60;font-size:15px}._17wZk{font-size:12px;color:#2e3333;font-style:italic;margin-top:10px;padding-left:10px}", ""]);

// exports
exports.locals = {
	"alcanceContent": "C_11B",
	"alcanceTitle": "_3q4vD",
	"porcentajeTable": "EMq0T",
	"comisionTable": "_1IC2I",
	"headerRow": "_3OfB3",
	"alcanceHeader": "_1S4KX",
	"membresiaHeader": "_1dwj7",
	"precioEsperado": "er8jf",
	"membresiaTitulo": "_2_GSQ",
	"rangoCell": "_28-sv",
	"sustituto": "_1E71u",
	"importeCell": "_1x3u2",
	"footnote": "_17wZk"
};